window.addEventListener('CartContentReloaded', function () {

    $('#international-checkout-button').click(function () {
        var destination = window.location.protocol + '//' + window.location.host + '/pages/globalshopex-checkout';
        window.location.href = destination;
    });

    $('.terms-checkbox').change(function () {
        // Since there are two checkboxes, one for desktop, and one for mobile,
        // check if the visible one is checked.

        // eslint-disable-next-line
        var visibleContainer = $('.policy-and-terms').filter(function (i, el) {
            var style = window.getComputedStyle(el);

            if (!style) {
                return false;
            }

            return style.display !== 'none';
        });

        if (!visibleContainer.length) {
            return;
        }

        // eslint-disable-next-line
        var disabled = !visibleContainer.find('[type="checkbox"]').is(':checked');
        $('.need-agreement').prop('disabled', disabled);
    });
});
